import { render, staticRenderFns } from "./AdminCampsRegistry.vue?vue&type=template&id=7a218ef4&lang=pug&"
import script from "./AdminCampsRegistry.vue?vue&type=script&lang=js&"
export * from "./AdminCampsRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports